<template>
    <div class="col-lg-12 col-md-12 col-sm-12">
      <c-table
        ref="table"
        title="취급일지 결과 목록"
        :columns="resultGrid.columns"
        gridHeight="530px"
        :data="data.resultList"
        :merge="resultGrid.merge"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        :hideBottom="true"
        :editable="editable && !disabled"
        rowKey="envDangerJournalResultId"
        @table-data-change="tableDataChange"
      >
        <template v-if="prevList && prevList.length>0"  slot="suffixTitle">
          <font class="text-negative" style="font-size:0.8em;font-weight:300;">
            ※ 저장소구분/저장품목에 대한 전일 재고량입니다. 전일 재고량은 자동으로 계산됩니다. 
          </font>
          <q-chip
            v-for="(prev, index) in prevList"
            :key="index"
            outline square 
            color="primary"
            text-color="white"
            class="q-ma-none customchipdept">
            <template>
              {{ '[' + prev.envDangerResultDate +'] ' }}
              {{prev.envDangerResultName}} : {{prev.envDangerStock + 'L'}}
            </template>
          </q-chip>
        </template>
      </c-table>
    </div>
</template>

<script>
export default {
  name: 'danger-journal-result',
  props: {
    data: {
      type: Object,
      default: () => ({
        resultList: [],
      }),
    },
    prevList: {
      type: Array,
      default: () => []
    },
    resultGrid: {
      columns: [],
      merge: [],
      height: '520px'
    },
  },
  data() {
    return {
      editable: true,
      searchUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      
    };
  },
  computed: {
    disabled() {
     return this.data.envDangerCompleteFlag === 'Y' || this.data.approvalStatusCd === 'ASC0000001'
    },
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
    },
    tableDataChange(props, col) {
      // envDangerStock
      if (col.name === 'envDangerIn' || col.name === 'envDangerOut') {
        let filterData = this.$_.sortBy(this.$_.filter(this.data.resultList, { 
          envDangerResultName: props.row.envDangerResultName,
        }), 'envDangerResultDate')
        let _idx = this.$_.findIndex(filterData, { envDangerResultDate: props.row.envDangerResultDate })
        let __idx = this.$_.findIndex(this.prevList, {envDangerResultName: props.row.envDangerResultName})
        if (_idx > 0) {
          this.$set(props.row, 'envDangerQuan', (Number(filterData[_idx - 1].envDangerStock) + Number(props.row.envDangerIn) - Number(props.row.envDangerOut)) / props.row.calcuMethod.split("/")[1])
          this.$set(props.row, 'envDangerStock', Number(filterData[_idx - 1].envDangerStock) + Number(props.row.envDangerIn) - Number(props.row.envDangerOut))
          // if (__idx >= 0) {
          //   // 인덱스값이 있을 경우 전일 재고량 + 입고량 - 사용량 계산
          //   this.$set(props.row, 'envDangerQuan', (Number(filterData[_idx - 1].envDangerStock) + Number(props.row.envDangerIn) - Number(props.row.envDangerOut)) / props.row.calcuMethod.split("/")[1])
          //   this.$set(props.row, 'envDangerStock', Number(filterData[_idx - 1].envDangerStock) + Number(props.row.envDangerIn) - Number(props.row.envDangerOut))
          //   // 없을 경우 전일 재고량 없이 계산 
          // } else {
          //   this.$set(props.row, 'envDangerQuan', (Number(props.row.envDangerIn) - Number(props.row.envDangerOut)) / props.row.calcuMethod.split("/")[1])
          //   this.$set(props.row, 'envDangerStock', Number(props.row.envDangerIn) - Number(props.row.envDangerOut))
          // }
        } else {
          // 전일 재고량 -> 날짜마다 구분이 여러개이기 때문에 필터링 시켜야함.
          if (__idx >= 0) {
            // 인덱스값이 있을 경우 전일 재고량 + 입고량 - 사용량 계산
            this.$set(props.row, 'envDangerQuan', (Number(this.prevList[__idx].envDangerStock) + Number(props.row.envDangerIn) - Number(props.row.envDangerOut)) / props.row.calcuMethod.split("/")[1])
            this.$set(props.row, 'envDangerStock', Number(this.prevList[__idx].envDangerStock) + Number(props.row.envDangerIn) - Number(props.row.envDangerOut))
            // 없을 경우 전일 재고량 없이 계산 
          } else {
            this.$set(props.row, 'envDangerQuan', (Number(props.row.envDangerIn) - Number(props.row.envDangerOut)) / props.row.calcuMethod.split("/")[1])
            this.$set(props.row, 'envDangerStock', Number(props.row.envDangerIn) - Number(props.row.envDangerOut))
          }
        }
        if (props.row.editFlag !== 'C') {
          this.$set(props.row, 'editFlag', 'U')
          this.$set(props.row, 'chgUserId', this.$store.getters.user.userId)
        }
        // 날짜의 입고량을 입력시 그 날 이후 전부 계산시킴.
        if (_idx + 1 < filterData.length) {
          for (let i = _idx + 1; i < filterData.length; i++) {
              this.$set(filterData[i], 'envDangerQuan', (Number(filterData[i - 1].envDangerStock) + Number(filterData[i].envDangerIn) - Number(filterData[i].envDangerOut)) / filterData[i].calcuMethod.split("/")[1])
              this.$set(filterData[i], 'envDangerStock', Number(filterData[i - 1].envDangerStock) + Number(filterData[i].envDangerIn) - Number(filterData[i].envDangerOut))
            if (filterData[i].editFlag !== 'C') {
              this.$set(filterData[i], 'editFlag', 'U')
              this.$set(filterData[i], 'chgUserId', this.$store.getters.user.userId)
            }
          }
        }
      }
    }
  }
};
</script>
